/*
  This file is a componet for the writings section of the portfolio site
    (blogs, reviews, etc).

  It contains all the code for that specific section of the site!!

*/


import React, { Component } from 'react';

class Writings extends Component {
  render() {
    return (
      <div> <h1>Writings Page</h1> </div>
    )
  }
}

export default Writings;
